import React, { useState, useEffect } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import { useOrderSave } from "../context/OrderSaveContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { showErrorToast, showSuccessToast } from "../components/toasts/ToastService";

const orrMerevitoTipusok = [
    { value: "Normál", label: "Normál anyagú és normál formájú" },
    { value: "Puha, kifli", label: "Puha anyagú és kifli formájú" },
];

const selectionMap = {
    "Normál": { type: "Normál formájú", mater: "Normál anyagú" },
    "Puha, kifli": { type: "Kifli formájú", mater: "Puha anyagú" },
    "": { type: "", mater: "" },
};

const getSelectionFromOrder = (type, mater) => {
    const entry = Object.entries(selectionMap).find(
        ([, mapped]) => mapped.type === type && mapped.mater === mater
    );
    if (entry) return entry[0];
    if (!type && !mater) return "";
    return null;
};


const OrrMerevito = () => {
    const { order, updateOrder } = useOrder();
    const { saveOrder } = useOrderSave();
    const navigate = useStepNavigate();

    const modellCode = (order.hmeliorder?.hmeliorder_modell_num ?? "").toString().trim();
    const isNoseBraceForbidden = modellCode.endsWith("3");

    const isSelectionValid = (value) =>
        isNoseBraceForbidden ? value === "" : Boolean(value);

    const [selected, setSelected] = useState(() => {
        const initial = getSelectionFromOrder(
            order.hmeliorder?.hmeliorder_nose_brace_type,
            order.hmeliorder?.hmeliorder_nose_brace_mater
        );
        return isNoseBraceForbidden ? "" : initial ?? "";
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isNoseBraceForbidden) return;
        if (selected === "") return;
        setSelected("");
    }, [isNoseBraceForbidden, selected]);

    const handleSelect = (value) => {
        if (isNoseBraceForbidden && value !== "") return;

        const { type, mater } = selectionMap[value] || selectionMap[""];
        setSelected(value);
        updateOrder({
            ...order,
            hmeliorder: {
                ...order.hmeliorder,
                hmeliorder_nose_brace_mater: mater,
                hmeliorder_nose_brace_type: type
            },
        });
    };

    const canProceed = isSelectionValid(selected);

    const handleNext = async () => {
        if (!canProceed) {
            showErrorToast("Kérem, válasszon orr merevítőt vagy válassza a 'Nem kell' opciót!");
            return;
        }

        const selectedKey = selected ?? "";
        const selectedSelection = selectionMap[selectedKey] || selectionMap[""];

        const updatedOrder = {
            ...order,
            hmeliorder: {
                ...order.hmeliorder,
                hmeliorder_nose_brace_type: selectedSelection.type,
                hmeliorder_nose_brace_mater: selectedSelection.mater,
            },
        };

        try {
            setLoading(true);
            updateOrder(updatedOrder);
            const result = await saveOrder(updatedOrder);

            if (result.success) {
                showSuccessToast("A rendelés sikeresen mentve!");
                navigate("/Donga");
            } else {
                showErrorToast("Hiba történt a rendelés mentésekor!");
            }
        } catch (error) {
            console.error("Orr merevítő mentési hiba:", error);
            showErrorToast("Hiba történt a rendelés mentésekor!");
        } finally {
            setLoading(false);
        }
    };

    const renderOrrMerevitoOptions = () => (
        <div className="mb-6 m-0">
            <div className="d-flex flex-column gap-3 align-items-center">
                {orrMerevitoTipusok.map((tipus) => (
                    <button
                        key={tipus.value}
                        type="button"
                        disabled={isNoseBraceForbidden && tipus.value !== ""}
                        className={`btn w-100 py-4 px-3 shadow-sm rounded-4 d-flex flex-column align-items-center fw-bold
                            ${selected === tipus.value
                                ? "btn-primary text-white"
                                : "btn-outline-primary text-primary border-primary"
                            }`}
                        style={{
                            fontSize: 20,
                            fontWeight: 600,
                            borderWidth: 2,
                            minHeight: 100,
                            minWidth: 500
                        }}
                        onClick={() => handleSelect(tipus.value)}
                    >
                        <span>{tipus.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );

    return (
        <TablerLayout title="Válassza ki az orr merevítőt!">
            <div className="row justify-content-center">
                <div className="col-md-12">
                    <div className="card-body">
                        <div className="col-md-12 d-flex justify-content-center gap-4">
                            {renderOrrMerevitoOptions()}
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-footer d-flex justify-content-between">
                <StepperNavButton
                    side="left"
                    label="Vissza"
                    onClick={() => navigate("/KeregTipus")}
                />
                <StepperNavButton
                    side="right"
                    label="Tovább"
                    onClick={handleNext}
                    disabled={!canProceed || loading}
                />
            </div>
        </TablerLayout>
    );
};

export default OrrMerevito;
